var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tooltip",
    {
      attrs: { disabled: _vm.text === null, bottom: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c(
                "v-chip",
                _vm._g(
                  {
                    staticClass: "travel-service-chips my-1",
                    attrs: { color: _vm.color, "text-color": _vm.textColor }
                  },
                  on
                ),
                [
                  _vm.icon !== null
                    ? _c("v-icon", { staticClass: "small mr-1 my-1" }, [
                        _vm._v(_vm._s(_vm.icon))
                      ])
                    : _vm._e(),
                  _vm._v(" " + _vm._s(_vm.tooltip) + " ")
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [_vm._v(" " + _vm._s(_vm.text) + " ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }